import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../pages/HomePage.vue';
import CertificateSearch from '../pages/CertificateSearch.vue';
import CertificateResult from '../pages/CertificateResult.vue';
import CertificatePreview from '../pages/CertificatePreview.vue';
import TeacherEvaluation from '../pages/TeacherEvaluation.vue';
import TeacherSearch from '../pages/TeacherSearch.vue';
import TeacherDetail from "../pages/TeacherDetail.vue";

Vue.use(VueRouter);

const routes = [
  { path: '/', component: HomePage },
  { path: '/certificate', component: CertificateSearch },
  { path: '/result', component: CertificateResult },
  { path: '/preview', component: CertificatePreview },
  { path: '/evaluation/:id', component: TeacherEvaluation },
  { path: '/teachers', component: TeacherSearch },
  { path: "/teacherdetail/:id", component: TeacherDetail },
];

export default new VueRouter({
  mode: 'hash',
  routes
});
